import React from "react";
import { Box, Typography, Container, Paper, Grid } from "@mui/material";
import ads from "../assets/ads.png";
import { useTheme } from "@mui/material/styles";
import SupportIcon from "../assets/sup.svg";
import SecurityIcon from "../assets/secure.svg";
import SpeedIcon from "../assets/instant.svg";
import MonetizationOnIcon from "../assets/wallet_icon-icons.com_65116.svg";
import AccountBalanceIcon from "../assets/phone.svg";
import TransparentIcon from "../assets/transparent.svg";
import Advertise01 from "../assets/Advertise01.png" 
import Advertise02 from "../assets/Advertise02.png"
import Advertise03 from "../assets/Advertise03.png"
import Advertise04 from "../assets/Advertise04.png"
import Carousel from 'react-material-ui-carousel'

const features = [
  { title: "24 Hrs Support", content: "We ensure full-time support to our clients. For any inconvenience, don’t hesitate to contact our help desk.", icon: SupportIcon },
  { title: "Secure", content: "Sava instant loan application process does not require physical document submission. Just fill in the details and upload a selfie.", icon: SecurityIcon },
  { title: "Flexible Loan Amount", content: "For cash emergencies, borrow cash from TZS 30,000 – TZS 500,000 within a minute. The amount gets deposited into your mobile money account.", icon: SpeedIcon },
  { title: "Instant Approval & Disbursal", content: "Sava instant loan application process ensures quick approvals. Just fill in the required details and get your loan instantly.", icon: MonetizationOnIcon },
  { title: "Paperless", content: "No need for physical paperwork. The process is entirely digital, ensuring a seamless experience.", icon: AccountBalanceIcon },
  { title: "Comprehensive Reports", content: "Experience our comprehensive reports with absolute clarity—no hidden charges and no pre-payment fees, ensuring you know exactly what to expect.", icon: TransparentIcon },
];


const imageData = [
  { id: 1, src: Advertise01, alt: "Advertisement 1" },
  { id: 2, src: Advertise02, alt: "Advertisement 2" },
  { id: 3, src: Advertise03, alt: "Advertisement 3" },
  { id: 4, src: Advertise04, alt: "Advertisement 4" }
];



const FeaturesSection = () => {
  const theme = useTheme();
  const leftFeatures = features.slice(0, 3); // First three items
  const rightFeatures = features.slice(3); // Last three items

  return (
    <Container
      sx={{
        backgroundColor: theme.palette.background.paper,
        marginTop: "20px",
        marginBottom: "100px",
        paddingX: { xs: 0, sm: 3, md: 4 },
      }}
    >
      <Paper sx={{ backgroundColor: "white", padding: "20px" }}>
        {/* Title Section */}
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Box
              sx={{
                backgroundColor: "white",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: { xs: "2px", md: "3px", lg: "10px" },
                flexDirection: { xs: "column", md: "row" },
                margin: { xs: "5px" },
              }}
            >
              <Box>
                <Typography color="black" variant="h6">
                  Features
                </Typography>
                <Typography color="black" variant="h4" fontWeight="bold">
                  Sava Loan
                </Typography>
                <Typography color="black" variant="body1">
                  Sava Loan streamlines the loan process, making it easy to manage applications, track repayments, and monitor loan statuses. It offers a simple, user-friendly platform that enhances efficiency.
                </Typography>
              </Box>

              {/* <Box
                component="img"
                src={ads}
                alt="Features Image"
                sx={{
                  borderRadius: "8px",
                  maxWidth: "100%",
                  width: { xs: "97%", sm: "40%", md: "40%", lg: "40%" },
                  height: "auto",
                  padding: { xs: "0px", md: "1px" },
                }}
              /> */}


<Carousel indicators={false} sx={{
                  borderRadius: "5px",
                  border: '1px black solid',
                  maxWidth: "100%",
                  width: { xs: "97%", sm: "100%", md: "100%", lg: "100%" },
                  height: "auto",
                  padding: { xs: "0px", md: "0px" },
                  marginTop:{xs:'15px'}
                }}>
            {imageData.map((item) => (
                <Box key={item.id} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <img src={item.src} alt={item.alt} style={{ width: '100%', height: 'auto', borderRadius:'5px'}} />
                </Box>
            ))}
        </Carousel>




            </Box>
          </Grid>
        </Grid>

        {/* Features Grid */}
        <Box
          sx={{
            height: "auto",
            backgroundColor: "white",
            marginY: "20px",
            padding: {xs:'0px', sm:'10px'},
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid container spacing={1}>
            {/* Left Content */}
            <Grid item xs={12} md={6} lg={6}>
              {leftFeatures.map((feature, idx) => (
                <Grid
                  key={idx}
                  container
                  spacing={0}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    backgroundColor: theme.palette.secondary.main,
                    marginY: "10px",
                    padding: {xs:'0px', sm:'10px'},
                    borderRadius: "5px",
                  }}
                >
                  <Grid item xs={2} sm={1}>
                    <Box
                      component="img"
                      src={feature.icon}
                      alt={feature.title}
                      sx={{ width: "30px", height: "30px" }}
                    />
                  </Grid>
                  <Grid item xs={10} sm={11}>
                    <Typography variant="h6" color="black">
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {feature.content}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            {/* Right Content */}
            <Grid item xs={12} md={6} lg={6}>
              {rightFeatures.map((feature, idx) => (
                <Grid
                  key={idx}
                  container
                  spacing={0}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    backgroundColor: theme.palette.secondary.main,
                    marginY: "10px",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <Grid item xs={2} sm={1}>
                    <Box
                      component="img"
                      src={feature.icon}
                      alt={feature.title}
                      sx={{ width: "30px", height: "30px" }}
                    />
                  </Grid>
                  <Grid item xs={10} sm={11}>
                    <Typography variant="h6" color="black">
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {feature.content}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
};

export default FeaturesSection;
